'use client';
import getLocal from '@/app/utils/getLocal';
import Language from '@/components/Language';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import Link from '@/components/utils/Link2';
import { getIsPadWidth } from '@elem/utils/devices';
import { useState } from 'react';
import css from './footer.module.scss';
import FooterEmailA from './FooterEmailA';
import { getFooterIconList } from './FooterIconList';
import FooterNoShareA from './FooterNoShareA';
import { i18nText } from './i18nText';

export default function Footer({ bottomList = [], theme = '' }: { bottomList: any; theme: string }) {
    const [openkey, setOpenkey] = useState<string>('');
    const { locale = 'us' } = getLocal();
    const IconList = getFooterIconList(locale);
    // 手机端切换显隐
    const toggleItem = (togglekey: string) => {
        const isMobile = getIsPadWidth(); //是否是移动端
        if (!isMobile) {
            return null;
        }
        let targetKey = togglekey;
        if (togglekey === openkey) {
            targetKey = '';
        }
        setOpenkey(targetKey);
    };
    return (
        <footer className={`${css.footer} ${theme} footer`}>
            <section className="footer-a">
                {bottomList?.detailList?.map((column: any, idx: number) => (
                    <div className={`fa-item${openkey == column.name ? ' opend' : ''}`} key={`${column.name}_${idx}`}>
                        <h3 onClick={() => toggleItem(column.name)}>{column.name}</h3>
                        <div className="fa-list">
                            {column.subs?.map((item: any, index2: number) => (
                                <Link
                                    href={item.url}
                                    key={`${item.heading}_${index2}`}
                                    className="GtmModuleData-btn-href"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'bottom_navigation',
                                        list_name: column.heading,
                                        navigation_name: item.heading,
                                        __btn_id1: `footer .footer-a`,
                                        __btn_id2: item.url,
                                        __btn_type: 'href',
                                    }}
                                >
                                    {item.heading}
                                </Link>
                            ))}
                        </div>
                    </div>
                ))}
                <div className="fa-itemb fa-item-lang-h5">
                    <div className="fa-itemb-desc">{i18nText[locale]?.site_bottom_select_tip || i18nText.en.site_bottom_select_tip}</div>
                    <div className="fa-itemb-title">
                        <Language />
                        <span className="fa-itemb-icon column-arr-right">
                            <EFArrowDown />
                        </span>
                    </div>
                </div>
            </section>
            <section className="footer-b">
                <IconList theme={theme} />
                <FooterEmailA theme={theme} />
            </section>
            <section className="footer-c">
                <div className="footer-c-in">
                    <div className="left">
                        {i18nText[locale]?.site_bottom_copyright.replace('{nowYear}', new Date().getFullYear()) ||
                            i18nText.en.site_bottom_copyright.replace('{nowYear}', new Date().getFullYear())}
                        {locale === 'cn' && (
                            <Link
                                href={'https://beian.miit.gov.cn/#/Integrated/index'}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'bottom_navigation',
                                    navigation_name: '备案号',
                                }}
                            >
                                粤ICP备2020097871号
                            </Link>
                        )}
                        <FooterNoShareA />

                        <div className="sdk-wrapper">
                            {locale === 'us' && (
                                <div className="cookies-settings">
                                    <a href="javascript:__cmp('showScreenAdvanced')"> Cookies Settings</a>
                                </div>
                            )}

                            {['us', 'ca'].includes(locale) && (
                                <>
                                    {locale === 'us' && <div className="divider"></div>}
                                    <div className="accessibility-settings">
                                        <a id="accessibility-settings"> Accessibility</a>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="right language-outbox fa-item-lang-pc">
                        {i18nText[locale]?.site_bottom_select_tip || i18nText.en.site_bottom_select_tip}
                        <Language />
                    </div>
                </div>
            </section>
        </footer>
    );
}
